import { ReactNode } from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import ControlPointIcon from '@mui/icons-material/ControlPoint';

export interface ICreateButtonProps {
  text?: string,
  children?: ReactNode,
}

export default function AddButton({ text, children, ...rest }: ICreateButtonProps & ButtonProps) {

  return (
    <Button startIcon={<ControlPointIcon/>} variant='outlined' {...rest}>{children || text}</Button>
  );
}
